import type { EnhancedAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export function isLng(auth: EnhancedAuthenticatedMonolithUser | null) {
  return Boolean(
    PRISMA_CONFIG.lngOperators.find(
      (referenceId) => auth?.isSso && String(auth.referenceId) === referenceId
    )
  );
}
